import React, { useMemo, useState } from 'react';
import isFunction from 'lodash/isFunction';

import useControlledState from '../../hooks/useControlledState';
import PopoverButton from '../PopoverButton';
import PopoverContent from '../PopoverContent';
import PopoverContext from '../PopoverContext';
import { PopoverComposition, PopoverProps } from './types';

const defaultValue = false;

const Popover: React.FC<PopoverProps> & PopoverComposition = (props) => {
  const { children, onOpenChange: onChange, open: controlledValue } = props;
  const [open, onOpenChange] = useControlledState({ controlledValue, defaultValue, onChange });

  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const value = useMemo(
    () => ({
      anchorEl,
      onClose: () => onOpenChange(false),
      onOpen: () => onOpenChange(true),
      onOpenChange,
      open: open!,
      setAnchorEl,
    }),
    [open, anchorEl, onOpenChange],
  );

  return (
    <PopoverContext.Provider value={value}>
      {isFunction(children) ? children(value) : children}
    </PopoverContext.Provider>
  );
};

Popover.Button = PopoverButton;
Popover.Content = PopoverContent;

export { PopoverProps };
export default Popover;
